<template>
<div>
  <com-header :compID="$route.params.id" activeKey="lxwm" @returnCompInfo="setCompInfo"></com-header>
  <div class="contact-view layout-router">
    <div class="left-m">
      <title-icon text="联系方式"></title-icon>
      <div class="contact-li one" v-if="compInfo.Phone">
        <i class="el-icon el-icon-phone-outline"></i>
        <div>
          <p>客服电话：</p>
          <p v-for="item in compInfo.Phone.split(',')" :key="item">{{item}}</p>
        </div>
      </div>
      <div class="contact-li">
        <i class="el-icon el-icon-location"></i>
        <div>
          <p>联系地址：</p>
          <p>{{compInfo.Province || ''}}{{compInfo.City || ''}}{{compInfo.District || ''}}{{compInfo.Address || ''}}</p>
        </div>
      </div>
      <div class="contact-li">
        <i class="el-icon el-icon-message"></i>
        <div>
          <p>客服邮箱</p>
          <p>{{compInfo.Email}}</p>
        </div>
      </div>
    </div>
    <div class="right-m">
      <title-icon text="交通地图"></title-icon>
      <div style="width: 786px; height: 300px;" id="mapContainer"></div>
    </div>
  </div>
</div>
</template>

<script>
import { ApiService } from '/@/service'
import { JsLoad } from '/@/utils/utils'
// import AMapLoader from "@amap/amap-jsapi-loader";
import {DomainService} from '@/libs'

import ComHeader from '/@/views/company/header/index.vue';
import TitleIcon from '/@/components/icon/title-icon.vue'

function bMapTransQQMap(lng, lat) {
        let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
        let x = lng - 0.0065;
        let y = lat - 0.006;
        let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
        let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
        let lngs = z * Math.cos(theta);
        let lats = z * Math.sin(theta);
        
        return {
            lng: lngs,
            lat: lats        
        }   
    }

export default {
  data() {
    return {
      compInfo: {},
      ApiService,
    }
  },
  components: { ComHeader, TitleIcon },
  methods: {
    setCompInfo(data) {
      this.compInfo = data;
      this.resetAMap();
    },
    // 反向解析地址
    async getGeocoder(chineseAddress) {
      const geocoder = new AMap.Geocoder({ city: "全国" });
        // 将中文地址转换为经纬度
        const geocodeResult = await new Promise((resolve, reject) => {
            geocoder.getLocation(chineseAddress, (status, result) => {
                if (status === 'complete' && result.info === 'OK') {
                    resolve(result);
                } else {
                    reject(new Error('无法获取地址的经纬度'));
                }
            });
        });
        // 获取第一个结果的经纬度
        const location = geocodeResult.geocodes ? geocodeResult.geocodes[0].location : {};
        const lng = location.lng;
        const lat = location.lat
        return [lng, lat];
    },
    async resetAMap() {
        window._AMapSecurityConfig = {
          securityJsCode: "e38abadc8246410884718fdc93abe7b5",
      };
      // const AMap = await JsLoad('AMap', 'https://webapi.amap.com/maps?v=2.0&key=44f2510db4035c4e33cc55ab4d00d391');
      const AMap = await JsLoad('AMap', 'https://webapi.amap.com/maps?v=2.0&key=071453cd0c720b3e318b48a8c3ea3811&plugin=AMap.Geocoder');
      let curLngLat = [];
      // 公司没有经纬度数据
      if(this.compInfo.MapLng ==0 && this.compInfo.MapLat ==0) {
        const address = `${this.compInfo.Province || ''}${this.compInfo.City || ''}${this.compInfo.District || ''}${this.compInfo.Address || ''}`;
        curLngLat = await this.getGeocoder(address);
      } else {
        // 为什么要计算，不知道，估计是后端来的数据是百度地图的，高德需要矫正
        const {lng, lat} = bMapTransQQMap(this.compInfo.MapLng || '', this.compInfo.MapLat || '');
        curLngLat = [lng, lat]
      }
      var map = new AMap.Map('mapContainer', {
          resizeEnable: true,
          zoom:11,
          center: curLngLat
      });
      var marker = new AMap.Marker({
          icon: `${DomainService.PublicPath}resource/position.png`,
          position: curLngLat,
          anchor:'bottom-center'
      });
      map.add(marker);
      map.setFitView();
    },
  }
}
</script>

<style lang="less" scoped>
.contact-view{
  min-height: calc(100vh - 189px - 32px);
  background: #FFFFFF;
  box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.1);
  display: flex;
}
.left-m{
  width: 370px;
  height: 370px;
  background: #FFFFFF;
  box-shadow: 0px 6px 11px 0px rgba(0,0,0,0.11);
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 30px;
}
.contact-li{
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  padding-left: 14px;
  p{
    margin: 0;
    color: @text-color-base;
    margin-top: 4px;
  }
  p:first-child{
    color: @text-color-help-dark;
  }
  /deep/ .el-icon{
    color: @a-color-active;
    margin-top: 4px;
    font-size: 18px;
    margin-right: 10px;
  }
}
.contact-li.one{
  margin-top: 22px;
}
.right-m{
  padding: 30px;
  flex: 1;
}
#mapContainer{
  background: @content-bg;
  margin-top: 14px;
  margin-left: 6px;
}
</style>
